
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from "@/components/ui/use-toast";
import { useState } from 'react';
import { Loader2 } from 'lucide-react';

interface AuthComponentProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const ADMIN_EMAIL = 'admin@trauredner-bayern.de';
const ADMIN_PASSWORD = 'Admin123!@#';

export const AuthComponent = ({ open, onOpenChange }: AuthComponentProps) => {
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(false);
  
  const handleLogin = async () => {
    setIsLoading(true);
    
    // Erst versuchen einzuloggen
    const { data: signInData, error: signInError } = await supabase.auth.signInWithPassword({
      email: ADMIN_EMAIL,
      password: ADMIN_PASSWORD
    });
    
    if (signInError) {
      console.log('Login attempt failed, trying to create user...', signInError.message);
      
      // Falls Login fehlschlägt, User erstellen
      if (signInError.message === 'Invalid login credentials') {
        const { data: signUpData, error: signUpError } = await supabase.auth.signUp({
          email: ADMIN_EMAIL,
          password: ADMIN_PASSWORD,
          options: {
            emailRedirectTo: window.location.origin
          }
        });
        
        if (signUpError) {
          console.error('Signup error:', signUpError);
          toast({
            title: "Fehler beim Erstellen des Admin-Users",
            description: signUpError.message,
            variant: "destructive",
          });
          setIsLoading(false);
          return;
        }
        
        console.log('User created, now logging in...');
        
        // Nach Erstellung direkt einloggen
        const { error: loginAfterSignupError } = await supabase.auth.signInWithPassword({
          email: ADMIN_EMAIL,
          password: ADMIN_PASSWORD
        });
        
        if (loginAfterSignupError) {
          console.error('Login after signup error:', loginAfterSignupError);
          toast({
            title: "Fehler beim Anmelden",
            description: loginAfterSignupError.message,
            variant: "destructive",
          });
          setIsLoading(false);
          return;
        }
        
        toast({
          title: "Admin-User erstellt und angemeldet",
          description: "Du bist jetzt als Admin eingeloggt.",
        });
        onOpenChange(false);
        setIsLoading(false);
        return;
      }
      
      // Anderer Fehler
      toast({
        title: "Fehler beim Anmelden",
        description: signInError.message,
        variant: "destructive",
      });
      setIsLoading(false);
      return;
    }
    
    // Login erfolgreich
    toast({
      title: "Erfolgreich angemeldet",
      description: "Du bist jetzt als Admin eingeloggt.",
    });
    onOpenChange(false);
    setIsLoading(false);
  };

  return (
    <DialogContent>
      <DialogHeader>
        <DialogTitle className="text-center">Admin-Bereich</DialogTitle>
      </DialogHeader>
      <div className="flex justify-center p-4">
        <Button onClick={handleLogin} className="w-full" disabled={isLoading}>
          {isLoading ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Anmelden...
            </>
          ) : (
            'Als Admin anmelden'
          )}
        </Button>
      </div>
    </DialogContent>
  );
};
